<template>
    <div>
        <el-button @click="toggleDescriptionVisibility" type="primary" style="margin-bottom:10px" plain>
            <template v-if="!isVisible"><i class="fa fa-angle-double-down" aria-hidden="true"></i> Show Job Description</template>
            <template v-else><i class="fa fa-angle-double-up" aria-hidden="true"></i> Hide Job Description</template>
        </el-button>

        <el-row v-show="isVisible">
            <el-col :span="24">
                <h2 style="margin-top:10px">Job Description</h2>
                <div v-html="description" class="description-body"></div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        props: {
            description: { type: String, required: true },
        },
        data() {
            return { isVisible: false };
        },
        methods: {
            toggleDescriptionVisibility() { this.isVisible = !this.isVisible; },
        },
    };
</script>

<style scoped>
    .description-body {
        border: 1px solid #d7dae2;
        border-radius: 5px;
        padding: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }
</style>